import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const SideMenu = props => {
  const { user } = props.auth;
  return (
    <aside className="main-sidebar">
      <section className="sidebar">
        <div className="user-panel">
          <div className="pull-left image">
            <img
              src={require("../../assets/dist/img/user2-160x160.jpg")}
              className="img-circle"
              alt="User Image"
            />
          </div>
          <div className="pull-left info">
            <p>{user.name}</p>

            <a>
              <i className="fa fa-circle text-success"></i> Online
            </a>
          </div>
        </div>

        {/*   <form  method="get" className="sidebar-form">
          <div className="input-group">
            <input
              type="text"
              name="q"
              className="form-control"
              placeholder="Search..."
            />
            <span className="input-group-btn">
              <button
                type="submit"
                name="search"
                id="search-btn"
                className="btn btn-flat"
              >
                <i className="fa fa-search"></i>
              </button>
            </span>
          </div>
        </form> */}

        <ul className="sidebar-menu">
          <li className="header">MAIN NAVIGATION</li>
          <li
            className={`${
              props.active === "dashboard" ? "active" : ""
            } treeview`}
          >
            <Link to={"/dashboard"}>
              <i className="fa fa-dashboard"></i> <span>Dashboard</span>
            </Link>
          </li>

          <li className={`${props.active === "user" ? "active" : ""} treeview`}>
            <Link to={"/user"}>
              <i className="fa fa-user"></i> <span>Users</span>
            </Link>
          </li>

          {/*    <li
            className={`${props.active === "admin" ? "active" : ""} treeview`}
          >
            <Link to={"/admin"}>
              <i className="fa fa-user"></i> <span>Admins</span>
            </Link>
          </li> */}

          {/*  <li
            className={`${
              props.active === "property" ? "active" : ""
            } treeview`}
          >
            <Link to={"/property"}>
              <i className="fa fa-user"></i> <span>Properties</span>
            </Link>
          </li> */}

          {/*          <li className="treeview">
            <a >
              <i className="fa fa-edit"></i> <span>Forms</span>
              <i className="fa fa-angle-left pull-right"></i>
            </a>
            <ul className="treeview-menu">
              <li>
                <a href="pages/forms/general.html">
                  <i className="fa fa-circle-o"></i> General Elements
                </a>
              </li>
              <li>
                <a href="pages/forms/advanced.html">
                  <i className="fa fa-circle-o"></i> Advanced Elements
                </a>
              </li>
              <li>
                <a href="pages/forms/editors.html">
                  <i className="fa fa-circle-o"></i> Editors
                </a>
              </li>
            </ul>
          </li>
          <li className="treeview">
            <a >
              <i className="fa fa-table"></i> <span>Tables</span>
              <i className="fa fa-angle-left pull-right"></i>
            </a>
            <ul className="treeview-menu">
              <li>
                <a href="pages/tables/simple.html">
                  <i className="fa fa-circle-o"></i> Simple tables
                </a>
              </li>
              <li>
                <a href="pages/tables/data.html">
                  <i className="fa fa-circle-o"></i> Data tables
                </a>
              </li>
            </ul>
          </li>
          <li className="treeview">
            <a >
              <i className="fa fa-table"></i> <span>Master</span>
              <i className="fa fa-angle-left pull-right"></i>
            </a>
            <ul className="treeview-menu">
              <li>
                <a href="pages/tables/simple.html">
                  <i className="fa fa-circle-o"></i> Simple tables
                </a>
              </li>
              <li>
                <a href="pages/tables/data.html">
                  <i className="fa fa-circle-o"></i> Data tables
                </a>
              </li>
            </ul>
          </li> */}
        </ul>
      </section>
    </aside>
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, {})(SideMenu);



// WEBPACK FOOTER //
// ./src/components/SideMenu/index.js